import {
  type AiFieldCellLoadingState,
  AiFieldThinkingPlaceholder,
  AiSummaryEmptyOutcomePlaceholder
} from '@databases/database-ai-fields';
import { DatabaseValueViewContainer } from '@databases/styles';
import type { DatabaseAiSummaryEmptyOutcome } from '@databases/types/database';
import React, { type FunctionComponent } from 'react';

import DatabaseValueView, { type DatabaseValueViewProps } from '../DatabaseValueView.tsx';

const AiSummaryFieldReadView: FunctionComponent<
  DatabaseValueViewProps & {
    emptyOutcome?: DatabaseAiSummaryEmptyOutcome['kind'];
    loadingState: AiFieldCellLoadingState;
  }
> = ({ contentId, emptyOutcome, fieldId, entryId, loadingState, ...props }) => {
  if (loadingState !== null) {
    return (
      <DatabaseValueViewContainer data-testid="database-value-view-container">
        <AiFieldThinkingPlaceholder loadingState={loadingState} />
      </DatabaseValueViewContainer>
    );
  }

  if (emptyOutcome !== undefined) {
    return (
      <DatabaseValueViewContainer data-testid="database-value-view-container">
        <AiSummaryEmptyOutcomePlaceholder outcome={emptyOutcome} />
      </DatabaseValueViewContainer>
    );
  }

  return (
    <DatabaseValueView
      {...props}
      contentId={contentId}
      fieldId={fieldId}
      entryId={entryId}
    />
  );
};

export default AiSummaryFieldReadView;
